import {PromoCodeType} from "../_enums/promo-code-type";
import {PromocodeDiscountType} from "../_enums/promocode-discount-type";

export class PromoCode {
  code: string = '';
  type?: PromoCodeType;
  discount_type?: PromocodeDiscountType;
  value?: number;
}
